// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__14g05","productName":"Table_productName__d6Cm_"};